module.exports = __webpack_public_path__ + "img/classrooms.90508486.svg";